import React, { useEffect, useState } from 'react'
import { SelectData } from '../style'
import axios from 'axios'
import { companyComponentsProps } from '../DisponibilityComponent'

export interface typesInterface {
  id?:number | number[]
  typeName:string
}

const SelectTypeComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  const [ types, setTypes ] = useState<typesInterface[]>([])

  const handleSeachTypes = () => {
    axios.get(`${process.env.REACT_APP_COMPANIES_BASE_URL}/companies/types`)
    .then(response => {
      if(response.data)
        setTypes(response.data)
      return
    })
    .catch(error => {
      console.error(error)
    })
  }

  const handleSetTypes = (e:any) => {
    setCompany((prev:any) => {
      const typeObject = types.filter(obj => obj.typeName === e.target.value)
      return {
        ...prev,
        companyTypes:typeObject[0] || {typeName:''}
      }
    })
  }
  
  return(
    <SelectData onFocus={handleSeachTypes} value={company.companyTypes.typeName} onChange={(e) => handleSetTypes(e)}>
      <option value={''}>Selecione</option>
      {types.map((item, index) => 
        <option key={index}>{item.typeName}</option>
      )}
    </SelectData>
  )
}

export default SelectTypeComponent